import { render, staticRenderFns } from "./RaisHistory.vue?vue&type=template&id=5afb3887&"
import script from "./RaisHistory.vue?vue&type=script&lang=ts&"
export * from "./RaisHistory.vue?vue&type=script&lang=ts&"
import style0 from "./RaisHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports